import { defineStore } from 'pinia'

import type {
	IAppOverlayOpenPayload,
	IAppOverlayProgress,
	IAppOverlayState
} from './appOverlayStoreTypes.ts'

const createInitialState = (): IAppOverlayState => ({
	isVisible: false,
	isLoading: true,
	title: '',
	message: '',
	progressLabel: '',
	progressPercent: 0
})

export const useAppOverlayStore = defineStore('app-overlay', {
	state: createInitialState,
	getters: {
		progress (state: IAppOverlayState): IAppOverlayProgress | undefined {
			if (!state.progressLabel) return undefined
			return {
				label: state.progressLabel,
				percent: state.progressPercent
			}
		}
	},
	actions: {
		open (payload: IAppOverlayOpenPayload): void {
			Object.assign(this, createInitialState(), payload, {
				isVisible: true
			})
		},
		setMessage (message: string): void {
			this.message = message
		},
		setTitle (title: string): void {
			this.title = title
		},
		setLoading (value: boolean): void {
			this.isLoading = value
		},
		startProgress (label: string): void {
			this.progressLabel = label
			this.progressPercent = 0
		},
		setProgressPercent (percent: number): void {
			const clamped = Math.max(0, Math.min(100, percent))
			this.progressPercent = Math.round(clamped)
		},
		clearProgress (): void {
			this.progressLabel = ''
			this.progressPercent = 0
		},
		close (): void {
			this.$patch(createInitialState())
		}
	}
})
